<template>
  <div class="relative">
    <AlertMobile v-if="windowWidth <= 992" @closeAlertMobile="hideAlertMobile = true" />
    <div class="vx-navbar-wrapper" :class="[classObj, closeAlert]">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <!-- v-if="windowWidth >= 992" -->
        <bookmarks :navbarColor="navbarColor" />

        <!-- <search-bar /> -->

        <vs-spacer />

        <!-- <help-center /> -->

        <advanced-search />

        <notification-drop-down />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import AdvancedSearch      from './components/AdvancedSearch.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import HelpCenter from './components/HelpCenter'
import AlertMobile from './components/AlertMobile'

export default {
  name: 'the-navbar-vertical',
  data() {
    return {
      hideAlertMobile: false
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    AdvancedSearch,
    HelpCenter,
    AlertMobile
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    },
    closeAlert(){
      if(this.hideAlertMobile){
        return 'hide-alert-mobile'
      }
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

